export const moneyFormat = (amount: bigint | number = 0) => {
  const formatter = new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount).replace("$", "");
};
